module.exports = __webpack_public_path__ + "img/制御工学2_8.88ed937a.png";